import { Routes } from '@angular/router';
import { ApiUpdateComponent } from './screens-top/api-update/api-update.component';

export const routes: Routes = [
  {
    path: 'upgrade-api-subcribe',
    component: ApiUpdateComponent
  }
];
